module.exports = "<div class=\"gw-modal-backdrop gw-fade\" ng-class=\"{'gw-in': animate}\" ng-style=\"{'z-index': 20010 + index*10}\">\n     <!--ng-click=\"close($event)\"--> <!-- B028003 We don't want the modal box to be closed while clicking on the backdrop -->\n</div>"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/widgets/modal/templates/modal-backdrop-template.html
// module id = 473
// module chunks = 0